import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";
import { MyReportDashboardResponse } from "../../types/my_reports.types";

export const getMyReportsDashboard = async (
	user_email: string
): Promise<MyReportDashboardResponse> => {
	try {
		const response = await axios.get(`${url}/my_reports/dashboard`, {
			params: {
				user_email,
			},
			...AuthHeader,
		});
		return response.data;
	} catch (error) {
		console.log("Fail to get my reports dashboard data", error);
		throw error;
	}
};
